import { AdjustmentType, RoundingMethod, RoundingType } from '@weareopenr/types';
import { FieldValues } from 'react-hook-form';

export interface IFormValues {
  name?: string;
  priceBands?: string[];
  selectedVenues?: string[];
}

export interface IRuleCalculationFields extends FieldValues {
  entities: string[];
  adjustment: {
    type: AdjustmentType;
    fixed?: number;
    percentage?: number;
  };
  rounding: {
    type: RoundingType;
    value?: number;
    method?: RoundingMethod;
  };
}

export enum RuleCalculationFields {
  ADJUSTMENT_TYPE = 'adjustment.type',
  ADJUSTMENT_FIXED = 'adjustment.fixed',
  ADJUSTMENT_PERCENTAGE = 'adjustment.percentage',
  ROUNDING_TYPE = 'rounding.type',
  ROUNDING_METHOD = 'rounding.method',
  ROUNDING_VALUE = 'rounding.value',
}

export interface IPriceBandFields extends IRuleCalculationFields {
  name: string;
}
